import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  dialogPaper: {
    width: '100%',
    margin: theme.spacing(2),
    maxHeight: 'calc(100% - 64px)',

    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(1),
      width: 'calc(100% - 20px)' // Força o respiro lateral no mobile
    }
  },
  title: {
    padding: '12px 24px 0px',
    color: theme.palette.blue_300.main,
    '& h2': {
      fontSize: '1.25rem'
    }
  },
  description: {
    fontSize: '0.875rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    marginBottom: 8
  },
  list: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '8px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  listItem: {
    borderRadius: 8,
    padding: '4px 16px',
    transition: 'background-color 0.3s, color 0.3s',
    '&:hover': {
      backgroundColor: theme.palette.blue_50.main,
      color: theme.palette.blue_300.main,
      '& .MuiListItemText-secondary': {
        color: theme.palette.blue_300.main
      }
    },
    '& .MuiListItemText-secondary': {
      fontSize: '0.75rem',
      transition: 'color 0.3s'
    },
    '& .MuiListItemText-multiline': {
      margin: '4px 0'
    }
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.blue_300.main
    }
  }
}))
